import { PrimaryColors } from '@/utils/constants';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { MuiCircularProgress } from '../material-ui';

const useContentLoaderStyles = makeStyles(
  () => ({
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,
      '&:before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: PrimaryColors.dark,
        opacity: 0.7,
      },
    },
  }),
  { name: 'ContentLoader' },
);

const ContentLoader = () => {
  const classes = useContentLoaderStyles();

  return (
    <div className={classes.root}>
      <MuiCircularProgress size="24px" color="secondary" />
    </div>
  );
};

export default ContentLoader;
